import { render, staticRenderFns } from "./userDashboardTerminationDialog.vue?vue&type=template&id=20aa3889"
import script from "./userDashboardTerminationDialog.vue?vue&type=script&lang=js"
export * from "./userDashboardTerminationDialog.vue?vue&type=script&lang=js"
import style0 from "./userDashboardTerminationDialog.vue?vue&type=style&index=0&id=20aa3889&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports